import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icon/Twitter.svg'
import _imports_1 from '@/assets/icon/metamask-fox.svg'


const _hoisted_1 = {
  key: 0,
  class: "fixed grid items-stretch h-screen w-screen z-30 place-content-center bg-black bg-opacity-50"
}
const _hoisted_2 = { class: "bg-white flex-col mx-auto w-auto h-auto shadow-md rounded px-8 pt-6 pb-8 mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "grid-cols-1"
}
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "username"
}
const _hoisted_6 = { class: "grid grid-cols-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 text-gray-700 px-4 py-2 text-sm" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-8 text-center",
    src: _imports_0
  })
], -1)
const _hoisted_8 = { class: "col-span-3 text-gray-700 px-4 py-2 text-sm" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 text-gray-700 px-4 py-2 text-sm" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-8 text-center",
    src: _imports_1
  })
], -1)
const _hoisted_10 = { class: "col-span-3 text-gray-700 px-4 py-2 text-sm" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "flex justify-end pt-4" }
const _hoisted_14 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TwitterLogin = _resolveComponent("TwitterLogin")!
  const _component_Wallet = _resolveComponent("Wallet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.isContentShown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (!_ctx.user?.user && _ctx.selectView)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("message.pleasesignin")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_TwitterLogin, { user: _ctx.user }, null, 8, ["user"])
                        ]),
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_Wallet, { user: _ctx.user }, null, 8, ["user"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.user.userType == 'twitter.com')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_TwitterLogin, { user: _ctx.user }, null, 8, ["user"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.user.userType == 'wallet')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_Wallet, { user: _ctx.user }, null, 8, ["user"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                    id: "Close",
                    class: "inline-block bg-gray-200 hover:bg-white rounded-full text-sm font-semibold text-gray-700 px-3 py-1",
                    type: "button"
                  }, " Close ")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.debugmessage), 1))
      : _createCommentVNode("", true)
  ], 64))
}